// extracted by mini-css-extract-plugin
module.exports = {"notification":"SwitchWithNotification_notification___9b9H","body":"SwitchWithNotification_body__2JgFm"};